import { render, staticRenderFns } from "./PromotionalImage.vue?vue&type=template&id=95caf1f8&scoped=true"
import script from "./PromotionalImage.vue?vue&type=script&lang=js"
export * from "./PromotionalImage.vue?vue&type=script&lang=js"
import style0 from "./PromotionalImage.vue?vue&type=style&index=0&id=95caf1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95caf1f8",
  null
  
)

export default component.exports